// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"layout_wrapper__inBif","body":"layout_body__DdiOy","header":"layout_header__x_N6R"};